export default __webpack_public_path__ + "static/media/olympiada.03b5b521.svg";